import React from 'react';
import { LayoutDashboard, ListMusic, BadgeIndianRupee, QrCode, RefreshCw, BarChart3 } from 'lucide-react';
export type AdminPage = 'dashboard' | 'playlists' | 'licences' | 'qr' | 'sync' | 'analytics';
const NAV: {
  id: AdminPage;
  label: string;
  icon: React.ReactNode;
}[] = [{
  id: 'dashboard',
  label: 'Dashboard',
  icon: <LayoutDashboard className="h-4 w-4" data-id="element-354" data-mp="258k77hkr7829" />
}, {
  id: 'playlists',
  label: 'Playlist Builder',
  icon: <ListMusic className="h-4 w-4" data-id="element-355" data-mp="1hig5xgv1fkef" />
}, {
  id: 'licences',
  label: 'Licence Policies',
  icon: <BadgeIndianRupee className="h-4 w-4" data-id="element-356" data-mp="1cko2pqoy0bux" />
}, {
  id: 'analytics',
  label: 'Analytics',
  icon: <BarChart3 className="h-4 w-4" data-id="element-357" data-mp="1qjnrqzgdasrm" />
}, {
  id: 'qr',
  label: 'QR Management',
  icon: <QrCode className="h-4 w-4" data-id="element-358" data-mp="1mh15rf6do22c" />
}, {
  id: 'sync',
  label: 'Content Sync',
  icon: <RefreshCw className="h-4 w-4" data-id="element-359" data-mp="31xrilwrns0sg" />
}];
export function AdminSidebar({
  page,
  onNavigate
}: {
  page: AdminPage;
  onNavigate: (p: AdminPage) => void;
}) {
  return <aside className="hidden w-60 shrink-0 flex-col bg-[#1e2a5a] py-3 text-slate-200 lg:flex" data-id="element-360" data-mp="2xyip8t0j64xf">
      <div className="px-4 pb-3" data-id="element-361" data-mp="t6na8igkfsua">
        <span className="font-heading text-lg font-extrabold tracking-tight text-white" data-id="element-362" data-mp="y3drh943wuha">
          RANG<span className="text-[#f4b8c0]" data-id="element-363" data-mp="125h25viybv1i">EE</span>T
        </span>
        <p className="mt-0.5 text-[11px] text-slate-400" data-id="element-364" data-mp="1234mxq4kvys5">Family App Admin</p>
      </div>
      <nav className="flex flex-1 flex-col gap-0.5 px-2" data-id="element-365" data-mp="173iwjcltvgsa">
        {NAV.map(item => {
        const active = page === item.id;
        return <button key={item.id} onClick={() => onNavigate(item.id)} className={`flex items-center gap-2.5 rounded-md px-3 py-2.5 text-sm font-medium transition ${active ? 'bg-white/15 text-white' : 'text-slate-300 hover:bg-white/5 hover:text-white'}`} data-id="element-366" data-mp="ef4ywxynimh9">
              {item.icon}
              {item.label}
            </button>;
      })}
      </nav>
      <div className="mt-auto px-4 pt-3 text-[10px] text-slate-500" data-id="element-367" data-mp="z02lwcgg7dan">
        v1.0.0 · July 2026
      </div>
    </aside>;
}